export type { ToggleSliderProps } from '../../components/ToggleSlider/ToggleSlider';
export { ToggleSlider } from '../../components/ToggleSlider/ToggleSlider';
